import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  fieldObjectInformes,
  headersInformes,
  valoresExibidosOffCanvasInformes,
} from './auxiliarInformes';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomButton from '../../../../components/CustomButton';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import SelectInput from '../../../../components/InputNew/Select';
import Tabela from '../../../../components/Tabela';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import BolinhaTabelaStatus from '../../../../components/bolinhaTabelaStatus';
import { getUser } from '../../../../modules/contexts/Auth/RequireAuth';
import { useAlcanceInforme } from '../../../../services/enum/useAlcanceInforme';
import { useImagemCard } from '../../../../services/enum/useImagemCard';
import { useStatusDisplayInforme } from '../../../../services/enum/useStatusDisplayInforme';
import { getAllInformes } from '../../../../services/gestaoSisAF/informesSisafService';
import { ENTITY } from '../../../../utils/entityNames';
import {
  formatDate,
  formataNomeMeioSiglas,
  formatDateSimp,
  ExportToExcel,
} from '../../../../utils/functions';
import { getSubAbas } from '../subabas';

const AdminInforme: React.FC = () => {
  //Dados do usuário
  const user = getUser();
  const userID = user.sub;
  const entity = ENTITY.ENTITY_InformesSisAF;
  const navigate = useNavigate();
  const alcanceInforme = useAlcanceInforme();
  const statusDisplay = useStatusDisplayInforme();
  const imagemCardTipo = useImagemCard();

  const alcanceBin = [
    { value: 0, label: 'Não informado' },
    { value: 1, label: 'Sim' },
    { value: 2, label: 'Não' },
  ];

  const [formFiltros, setFormFiltros] = useState({
    alcanceDaf: '',
    alcanceFornecedor: '',
    alcanceSes: '',
    statusDisplay: '',
    titulo: '',
  });
  const [data, setData] = useState<any[]>([]);

  const fetchData = async () => {
    try {
      const registros = await getAllInformes();
      setData(registros);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleClickInserir = () => {
    navigate('ficha/dadosgerais');
  };

  //Dados da tabela
  const tableData = data
    .filter((item: any) => {
      const alcanceSesNumber = formFiltros.alcanceSes === '1' ? 'S' : 'N';
      const alcanceFornecedorNumber =
        formFiltros.alcanceFornecedor === '1' ? 'S' : 'N';

      return (
        (formFiltros.statusDisplay === '' ||
          item.statusDisplay === Number(formFiltros.statusDisplay)) &&
        (formFiltros.alcanceDaf === '' ||
          item.alcanceDaf === Number(formFiltros.alcanceDaf)) &&
        (formFiltros.alcanceFornecedor === '' ||
          item.alcanceFornecedor === alcanceFornecedorNumber) &&
        (formFiltros.alcanceSes === '' ||
          item.alcanceSes === alcanceSesNumber) &&
        (formFiltros.titulo === '' ||
          item.titulo.toLowerCase().includes(formFiltros.titulo.toLowerCase()))
      );
    })

    .map((item) => {
      // Definir o status como 'S' ou 'N' baseado no valor de statusVersao
      const status = item.statusDisplay === 1 ? 'S' : 'N';

      return {
        id: item.id,
        statusDisplay: (
          <>
            <BolinhaTabelaStatus status={status} />
          </>
        ),
        dataInforme: formatDateSimp(item.dataInforme),
        alcanceDaf: alcanceInforme[item.alcanceDaf].label,
        alcanceSes: item.alcanceSes === 'N' ? 'Não' : 'Sim',
        alcanceFornecedor: item.alcanceFornecedor === 'N' ? 'Não' : 'Sim',
        titulo: item.titulo,
      };
    });

  //Dados do Offcanvas
  const offCanvasData = data.map((item) => ({
    id: item.id,
    dataRegistro:
      formatDate(item.dataRegistro) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
    dataUltimaAtualizacao:
      formatDate(item.dataUltimaAtualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),

    dataUltimaVisualizacao:
      formatDate(item.dataUltimaVisualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
    nEdicoes: item.nEdicoes,
    nVisualizacoes: item.nVisualizacoes,

    separadorLog: '',

    statusDisplay: statusDisplay[item.statusDisplay].label,
    dataInforme: formatDateSimp(item.dataInforme),
    alcanceDaf: alcanceInforme[item.alcanceDaf].label,
    alcanceFornecedor: item.alcanceFornecedor === 'S' ? 'Sim' : 'Não',
    alcanceSes: item.alcanceSes === 'S' ? 'Sim' : 'Não',
    imagemCard: imagemCardTipo[item.imagemCard].label,

    separadorEspecifico1: '',

    titulo: item.titulo,
    resumo: item.resumo,
    descricao: item.descricao,

    separadorEspecifico2: '',

    urlMaisInfor:
      item.urlMaisInfor === '' ? (
        'Não informado'
      ) : (
        <a href={item.link} target="_blank" rel="noopener noreferrer">
          {item.urlMaisInfor}
        </a>
      ),

    separadorObservacoes: '',
    observacoes: item.observacoes,
  }));

  const handleClearFiltros = () => {
    setFormFiltros({
      ...formFiltros,
      alcanceDaf: '',
      alcanceFornecedor: '',
      alcanceSes: '',
      statusDisplay: '',
      titulo: '',
    });
  };

  //Funções Handle
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.target;

    setFormFiltros((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  interface ExportData {
    id: number;
    dataRegistro: string;
    usuarioRegistro: {
      nomeCompleto: string;
    };
    dataUltimaAtualizacao: string;
    usuarioAtualizacao: {
      nomeCompleto: string;
    };
    dataUltimaVisualizacao: string;
    usuarioUltimaVisualizacao: {
      nomeCompleto: string;
    };
    nEdicoes: number;
    nVisualizacoes: number;
    nVisualizadores: number;

    //Específicos
    statusDisplay: number;
    alcanceDaf: number;
    alcanceFornecedor: number;
    alcanceSes: number;
    imagemCard: number;
    dataInforme: string;
    titulo: string;
    resumo: string;
    descricao: string;
    urlMaisInfor: string;

    //Observações
    observacoes: string;
  }

  const prepareDataForExport = (data: ExportData[]) => {
    return data.map((item) => {
      return {
        id: item.id,

        //Logs
        dataRegistro: item.dataRegistro,
        usuarioRegistro: item.usuarioRegistro.nomeCompleto,
        dataUltimaAtualizacao: item.dataUltimaAtualizacao,
        usuarioAtualizacao: item.usuarioAtualizacao.nomeCompleto,
        dataUltimaVisualizacao: item.dataUltimaVisualizacao,
        usuarioUltimaVisualizacao: item.usuarioUltimaVisualizacao.nomeCompleto,
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
        nVisualizadores: item.nVisualizadores,

        //Específicos
        statusDisplay: statusDisplay[item.statusDisplay]?.label || '-',
        alcanceDaf: alcanceInforme[item.alcanceDaf]?.label || '-',
        alcanceSes: alcanceBin[item.alcanceSes]?.label || '-',
        alcanceFornecedor: alcanceBin[item.alcanceFornecedor]?.label || '-',
        imagemCard: imagemCardTipo[item.imagemCard]?.label || '-',
        dataInforme: item.dataInforme,
        titulo: item.titulo,
        resumo: item.resumo,
        descricao: item.descricao,
        urlMaisInfor: item.urlMaisInfor,

        //Observações
        observacoes: item.observacoes,
      };
    });
  };

  const filteredDataForExport = data.filter((item) => {
    const alcanceSesNumber = formFiltros.alcanceSes === '1' ? 'S' : 'N';
    const alcanceFornecedorNumber =
      formFiltros.alcanceFornecedor === '1' ? 'S' : 'N';

    return (
      (formFiltros.statusDisplay === '' ||
        item.statusDisplay === Number(formFiltros.statusDisplay)) &&
      (formFiltros.alcanceDaf === '' ||
        item.alcanceDaf === Number(formFiltros.alcanceDaf)) &&
      (formFiltros.alcanceFornecedor === '' ||
        item.alcanceFornecedor === alcanceFornecedorNumber) &&
      (formFiltros.alcanceSes === '' || item.alcanceSes === alcanceSesNumber) &&
      (formFiltros.titulo === '' ||
        item.titulo.toLowerCase().includes(formFiltros.titulo.toLowerCase()))
    );
  });

  return (
    <>
      <BarraSubAbas subAbas={getSubAbas()} />

      <ContainerConteudo>
        <BoxConteudo boxTitulo="Filtros">
          <CustomRow style={{ marginTop: '-15px' }}>
            <CustomCol width="200px">
              <SelectInput
                name="statusDisplay"
                options={statusDisplay}
                label="Status"
                value={formFiltros.statusDisplay}
                onChange={handleChange}
              />
            </CustomCol>
            <CustomCol width="250px">
              <SelectInput
                name="alcanceDaf"
                options={alcanceInforme}
                label="DAF"
                value={formFiltros.alcanceDaf}
                onChange={handleChange}
              />
            </CustomCol>
            <CustomCol width="250px">
              <SelectInput
                name="alcanceSes"
                options={alcanceBin}
                label="SES"
                value={formFiltros.alcanceSes}
                onChange={handleChange}
              />
            </CustomCol>
            <CustomCol width="250px">
              <SelectInput
                name="alcanceFornecedor"
                options={alcanceBin}
                label="Fornecedor"
                value={formFiltros.alcanceFornecedor}
                onChange={handleChange}
              />
            </CustomCol>
            <CustomCol>
              <Input
                name="titulo"
                label="Título"
                value={formFiltros.titulo}
                id="titulo"
                onChange={handleChange}
              />
            </CustomCol>
          </CustomRow>
          <CustomRow style={{ marginTop: '-15px', textAlign: 'right' }}>
            <CustomCol className="mt-3 justify-content-end align-content-end">
              <CustomButton
                label="Limpar filtros"
                bgColor="#808080" // Cor cinza
                textColor="#ffffff" // Texto branco
                onClick={handleClearFiltros}
              />
            </CustomCol>
          </CustomRow>
        </BoxConteudo>

        <Tabela
          headers={headersInformes}
          dataTable={tableData}
          dataOffCanvas={offCanvasData}
          displayValues={valoresExibidosOffCanvasInformes}
          tituloCanvas="INFORME SISAF"
        />
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          download
          onClickDownload={() =>
            ExportToExcel(
              prepareDataForExport(filteredDataForExport),
              valoresExibidosOffCanvasInformes,
              fieldObjectInformes,
              'sisaf_informes.xlsx',
              userID,
              'DAF', // Nome da interface
              entity, // Nome da entidade
            )
          }
          inserir
          onClickInserir={handleClickInserir}
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default AdminInforme;
